import { EmploymentViewModel, EmploymentViewModelNew } from '@fora-monorepo/employer-my-pages-common/types';

// TODO: REMOVE filterListIndicesOld function Manage employments

export const filterListIndicesOld = ({
  employmentList,
  searchQuery,
}: {
  employmentList: EmploymentViewModel[];
  searchQuery?: string;
}): number[] => {
  let employmentListIndices: number[] = [];
  if (searchQuery) {
    const searchQueryWithoutHyphen = searchQuery.replace(/-/g, '');

    employmentListIndices = employmentList.reduce((prevValue, currentValue, currentIndex) => {
      const fullName = `${currentValue.employee.firstName} ${currentValue.employee.lastName}`;
      const employeeId = currentValue.employee.employeeId;
      try {
        if (
          employeeId.includes(searchQueryWithoutHyphen) ||
          fullName.toLowerCase().includes(searchQueryWithoutHyphen.toLowerCase())
        ) {
          return [...prevValue, currentIndex];
        } else {
          return prevValue;
        }
      } catch {
        return prevValue;
      }
    }, [] as number[]);
  } else {
    employmentListIndices = employmentList.map((_, ind) => ind);
  }
  return employmentListIndices;
};

export const filterListIndices = ({
  employmentList,
  searchQuery,
  showTerminatedEmployments,
  showActiveEmployments,
  showFutureEmployments,
}: {
  employmentList: EmploymentViewModelNew[];
  searchQuery?: string;
  showTerminatedEmployments?: boolean;
  showActiveEmployments?: boolean;
  showFutureEmployments?: boolean;
}): number[] => {
  const noFiltersApplied =
    !searchQuery && !showTerminatedEmployments && !showActiveEmployments && !showFutureEmployments;
  if (noFiltersApplied) {
    return employmentList.map((_, index) => index);
  }

  const searchQueryWithoutHyphen = searchQuery?.replace(/-/g, '').toLowerCase() ?? '';

  return employmentList.reduce<number[]>((prevValue, employment, currentIndex) => {
    const { firstName, lastName, employeeId } = employment.employee;
    const fullName = `${firstName} ${lastName}`.toLowerCase();

    const hasMatchBySearchQuery =
      fullName.includes(searchQueryWithoutHyphen) || employeeId.includes(searchQueryWithoutHyphen);
    const hasMatchByTerminatedEmploymentFilter = showTerminatedEmployments && employment.isTerminated;
    const hasMatchByActiveEmploymentFilter = showActiveEmployments && !employment.isInactive;
    const hasMatchByFutureEmploymentFilter = showFutureEmployments && employment.isFuture;

    const hasUnselectedAllFilters = !showTerminatedEmployments && !showActiveEmployments && !showFutureEmployments;

    if (
      hasMatchBySearchQuery &&
      (hasMatchByTerminatedEmploymentFilter ||
        hasMatchByFutureEmploymentFilter ||
        hasMatchByActiveEmploymentFilter ||
        hasUnselectedAllFilters)
    ) {
      return [...prevValue, currentIndex];
    }

    return prevValue;
  }, []);
};
